import React from 'react';

import PlaceHolder from '../component/PlaceHolder';


export default () => {
  return <PlaceHolder txt='后台开发中……'/>
};